export const languages = [
  { countryCode: 'af', name: 'Afrikaans' },
  { countryCode: 'ar', name: 'Arabic' },
  { countryCode: 'bn', name: 'Bengali' },
  { countryCode: 'bg', name: 'Bulgarian' },
  { countryCode: 'hr', name: 'Croatian' },
  { countryCode: 'cs', name: 'Czech' },
  { countryCode: 'dk', name: 'Danish' },
  { countryCode: 'nl', name: 'Dutch' },
  { countryCode: 'en', name: 'English (US)' },
  { countryCode: 'en-GB', name: 'English (UK)' },
  { countryCode: 'fil', name: 'Filipino' },
  { countryCode: 'fi', name: 'Finnish' },
  { countryCode: 'fr', name: 'French' },
  { countryCode: 'de', name: 'German' },
  { countryCode: 'el', name: 'Greek' },
  { countryCode: 'hu', name: 'Hungarian' },
  { countryCode: 'id', name: 'Indonesian' },
  { countryCode: 'it', name: 'Italian' },
  { countryCode: 'ja', name: 'Japanese' },
  { countryCode: 'ko', name: 'Korean' },
  { countryCode: 'lt', name: 'Lithuanian' },
  { countryCode: 'ms', name: 'Malay' },
  { countryCode: 'mr', name: 'Marathi' },
  { countryCode: 'no', name: 'Norwegian' },
  { countryCode: 'fa', name: 'Persian' },
  { countryCode: 'pl', name: 'Polish' },
  { countryCode: 'pt', name: 'Portuguese' },
  { countryCode: 'ro', name: 'Romanian' },
  { countryCode: 'ru', name: 'Russian' },
  { countryCode: 'zh-Hans', name: 'Simplified Chinese' },
  { countryCode: 'sk', name: 'Slovak' },
  { countryCode: 'es', name: 'Spanish' },
  { countryCode: 'sw', name: 'Swahili' },
  { countryCode: 'sv', name: 'Swedish' },
  { countryCode: 'ta', name: 'Tamil' },
  { countryCode: 'te', name: 'Telugu' },
  { countryCode: 'th', name: 'Thai' },
  { countryCode: 'zh-Hant', name: 'Traditional Chinese' },
  { countryCode: 'tr', name: 'Turkish' },
  { countryCode: 'uk', name: 'Ukrainian' },
  { countryCode: 'ur', name: 'Urdu' },
  { countryCode: 'vi', name: 'Vietnamese' },
]

export const defaultEmailSettings = [
  {
    key: 'login_mail_subject',
    countryCode: 'en',
    text: 'Your request to access {title}',
    display: true,
  },
  {
    key: 'double_optin',
    countryCode: 'en',
    text: `<!DOCTYPE html>
    <html lang="en">

    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style></style>
    </head>

    
    <body style="font-family: Arial; margin: 0; padding: 0; text-align: center">
    <div style="
            width: 100%;
            max-width: 850px;
            margin: auto;
            box-sizing: border-box;
          ">
        <!-- Email Content -->
        <div style="
              background: #fff;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            ">
            <!-- Header Image -->
            <table>
                <tr>
                    <td>
                        <img src="{ImgUrl}" alt="Course Image" style="max-width: 100%; height: auto; border: 0" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            Hi
                            <span style="font-weight: 600; font-size: 18px; color: black">{FirstName}</span>,
                        </p>
                    </td>
                </tr>

                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            You are receiving this email because you provided your email
                            address to access:
                        </p>
                        <p style="font-weight: 600; font-size: 18px; color: black">
                            {CollectionName}
                        </p>
                    </td>
                </tr>

                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            To begin viewing the course, simply click the button below.
                        </p>
                    </td>
                </tr>

                <tr>
                    <td style="text-align: center">
                <a href="{Url}" style="
                    display: inline-block; 
                    background-color: #015ffb;
                     color: white; 
                     padding: 20px 40px;
                      border-radius: 16px; 
                      text-decoration: none;"><span style="font-size: 18px; font-weight: 500; color: white">Verify email address</span></a>
                    </td>
                </tr>
            </table>

            <!-- Call to Action Button -->
        </div>

        <!-- Footer -->
        <table style="margin: 30px auto">
            <tr>
                <td>
                    <p style="
                    font-size: 16px;
                    font-weight: 500;
                    margin: 0;
                    color: #002e47;
                  ">
                        💡 Please note:
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    <ol style="
                    list-style: none;
                    padding: 0;
                    margin: 0 auto;
                    margin-bottom: 20px;
                  ">
                        <li style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    ">
                            1. This personalized link for seamless access expires once
                            clicked.
                        </li>
                        <li style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    ">
                            2. If you did not request this email, please simply ignore it.
                        </li>
                    </ol>
                </td>
            </tr>
            <tr>
                <td>
                    <div style="
                    color: #999;
                    background-color: #f4f6f8;
                    padding: 24px;
                    border-radius: 20px;
                  ">
                        <p style="font-size: 16px; font-weight: 500; color: #637381">
                            If you have trouble with the button, you can copy and paste the
                            link below into your browser:
                        </p>
                        <div
                style="
                  word-wrap: break-word;
                  word-break: break-all;
                  width: 100%;
                  max-width: 100%;
                "
              >
                <a
                  style="
                    word-wrap: break-word;
                    word-break: break-all;
                    white-space: normal;
                  "
                  href="{Url}"
                  >{Url}</a
                >
              </div>
                    </div>
                </td>
            </tr>
        </table>

        <!-- Note Section with Background Color -->
    </div>
    </body>

    </html>`,
    display: true,
  },
  {
    key: 'paid_login',
    countryCode: 'en',
    text: `<!DOCTYPE html>
    <html lang="en">

    <head>
        <meta charset="UTF-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
        <style></style>
    </head>

    <body style="font-family: Arial; margin: 0; padding: 0; text-align: center">
    <div style="
            width: 100%;
            max-width: 850px;
            margin: auto;
            box-sizing: border-box;
          ">
        <!-- Email Content -->
        <div style="
              background: #fff;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            ">
            <!-- Header Image -->
            <table>
                <tr>
                    <td>
                        <img src="{ImgUrl}" alt="Course Image" style="max-width: 100%; height: auto; border: 0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            Hi
                            <span style="font-weight: 600; font-size: 18px; color: black">{FirstName}</span>,
                        </p>
                    </td>
                </tr>

                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            You are receiving this email because you provided your email
                            address to access:
                        </p>
                        <p style="font-weight: 600; font-size: 18px; color: black">
                            {CollectionName}
                        </p>
                    </td>
                </tr>

                <tr>
                    <td>
                        <div style="
                                color: #002E47;
                                background-color: #E3F3FF;
                                padding: 24px;
                                border-radius: 20px;
                              ">
                            <p style="font-size: 18px; font-weight: 400; color: #002E47">
                                🔒 To access the course, you will be directed to the payment page first.
                                Simply click the button below to get started
                            </p>
                        </div>
                        <br/>
                    </td>
                </tr>

                <tr>
                    <td style="text-align: center; height: 60px">
                        <a href="{Url}" style="
                      background-color: #015ffb;
                      color: white;
                      padding: 20px 40px;
                      width: 360px;
                      height: 60px;
                      border-radius: 16px;
                      text-decoration: none;
                      margin-top: 20px;
                    "><span style="font-size: 18px; font-weight: 500; color: white">Proceed to Pay</span></a>
                    </td>
                </tr>
            </table>

            <!-- Call to Action Button -->
        </div>

        <!-- Footer -->
        <table style="margin: 30px auto">
            <tr>
                <td>
                    <p style="
                    font-size: 16px;
                    font-weight: 500;
                    margin: 0;
                    color: #002e47;
                  ">
                        💡 Please note:
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    <ol style="
                    list-style: none;
                    padding: 0;
                    margin: 0 auto;
                    margin-bottom: 20px;
                  ">
                        <li style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    ">
                            1. This personalized link for seamless access expires once
                            clicked.
                        </li>
                        <li style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    ">
                            2. If you did not request this email, please simply ignore it.
                        </li>
                    </ol>
                </td>
            </tr>
            <tr>
                <td>
                    <div style="
                    color: #999;
                    background-color: #f4f6f8;
                    padding: 24px;
                    border-radius: 20px;
                  ">
                        <p style="font-size: 16px; font-weight: 500; color: #637381">
                            If you have trouble with the button, you can copy and paste the
                            link below into your browser:
                        </p>
                        <a href="{Url}">{Url}</a>
                    </div>
                </td>
            </tr>
        </table>

        <!-- Note Section with Background Color -->
    </div>
    </body>

    </html>`,
    display: true,
  },
  {
    key: 'paid_order',
    countryCode: 'en',
    text: `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style></style>
    </head>

    <body style="font-family: Arial; margin: 0; padding: 0; text-align: center">
    <div
            style="
            width: 100%;
            max-width: 850px;
            margin: auto;
            box-sizing: border-box;
          "
    >
        <!-- Email Content -->
        <div
                style="
              background: #fff;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
        >
            <!-- Header Image -->
            <table>
                <tr>
                    <td>
                        <img
                                src="{ImgUrl}"
                                alt="Course Image"
                                style="max-width: 100%; height: auto; border: 0"
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p style="font-size: 18px; font-weight: 400; color: #002e47">
                            Thank you!
                            <span style="font-weight: 600; font-size: 18px; color: black"
                            >{FirstName}</span
                            >,
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p style="font-weight: 600; font-size: 18px; color: black">
                            Great, you unlocked the course! 🎉
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div
                                style="
                      color: #002e47;
                      background-color: #e3f3ff;
                      padding: 24px;
                      border-radius: 20px;
                      width: 840px;
                    "
                        >
                            <p style="font-size: 18px; font-weight: 400; color: #002e47">
                                You can now access all the amazing content in
                                <span style="font-weight: 600; font-size: 18px; color: black"
                                >{CollectionName}.</span
                                >,
                            </p>
                            <p style="font-size: 18px; font-weight: 400; color: #002e47">
                                To view the course, simply click the link below.
                            </p>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td style="text-align: center; height: 61px; padding: 20px 40px">
                        <a
                                href="{Url}"
                                style="
                      background-color: #015ffb;
                      color: white;
                      padding: 20px 40px;
                      border-radius: 16px;
                      text-decoration: none;
                      margin-top: 20px;
                    "
                        ><span style="font-size: 18px; font-weight: 500; color: white"
                        >View Course</span
                        ></a
                        >
                    </td>
                </tr>
            </table>

            <!-- Call to Action Button -->
        </div>

        <!-- Footer -->
        <table style="margin: 0 auto">
            <tr>
                <td>
                    <p
                            style="
                    font-size: 16px;
                    font-weight: 500;
                    margin: 0;
                    color: #002e47;
                  "
                    >
                        💡 Please note:
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    <ol
                            style="
                    list-style: none;
                    padding: 0;
                    margin: 0 auto;
                    margin-bottom: 20px;
                  "
                    >
                        <li
                                style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    "
                        >
                            1. This personalized link for seamless access expires once
                            clicked.
                        </li>
                        <li
                                style="
                      font-size: 16px;
                      font-weight: 500;
                      color: #002e47;
                      margin-top: 10px;
                    "
                        >
                            2. If you did not request this email, please simply ignore it.
                        </li>
                    </ol>
                </td>
            </tr>
            <tr>
                <td>
                    <div
                            style="
                    color: #999;
                    background-color: #f4f6f8;
                    padding: 24px;
                    border-radius: 20px;
                  "
                    >
                        <p style="font-size: 16px; font-weight: 500; color: #637381">
                            If you have trouble with the button, you can copy and paste the
                            link below into your browser:
                        </p>
                        <a href="{Url}">{Url}</a>
                    </div>
                </td>
            </tr>
        </table>

        <!-- Note Section with Background Color -->
    </div>
    </body>
    </html>`,
    display: true,
  },
  {
    key: 'invite_member_subject',
    countryCode: 'en',
    text: 'Gain access for {CollectionName}',
    display: false,
  },
  {
    key: 'double_optin_confirmation_mail',
    countryCode: 'en',
    text: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Verification Code</title>
  <style>
    body {margin: 0; padding: 0; font-family: Inter; background-color: #f4f6f8;}
    .email-container {width: 100%; max-width: 640px; margin: 0 auto; background-color: #f4f6f8; padding: 32px 152px; box-sizing: border-box;}
    .main-content {background-color: white; border-radius: 20px; overflow: hidden;}
    .header-section {padding: 40px; text-align: left;}
    .logo-container {display: inline-flex; align-items: center; gap: 8.53px;}
    .logo-icon, .logo-text {background: linear-gradient(131deg, #6fb6fe 0%, #4ea6ff 48%, #6fb6fe 100%);}
    .content-section {padding: 0 40px 0 40px;}
    .greeting, .message {color: #002e47; font-size: 18px; font-weight: 500; margin: 0 0 16px 0;}
    .verification-code {color: #015ffb; font-size: 24px; font-weight: 600; line-height: 36px; margin: 0 0 16px 0;}
    .warning {color: #002e47; font-size: 16px; font-weight: 400; line-height: 24px; margin: 0 0 16px 0;}
    .footer-note {color: #002e47; font-size: 14px; font-weight: 400; line-height: 21px; margin: 0 0 20px 0;}
    .footer-note a {color: #002e47; text-decoration: underline;}
    .divider {height: 1px; background-color: #e5e7eb; margin: 20px 0;}
    .footer-section {padding: 40px; background-color: white;}
    .footer-text {color: #637381; font-size: 14px; font-weight: 400; line-height: 21px; margin: 0;}
    .bottom-links {padding: 20px 40px; text-align: center;}
    .links-container {display: inline-flex; align-items: center; gap: 20px; margin-bottom: 16px;}
    .link-separator {width: 1px; height: 20px; background-color: #838d98;}
    .bottom-link {color: #838d98; font-size: 14px; font-family: Poppins, Arial, sans-serif; font-weight: 400; text-decoration: underline; line-height: 24px;}
    .copyright {color: #838d98; font-size: 14px; font-family: Poppins, Arial, sans-serif; font-weight: 400; line-height: 24px; margin: 0;}
    @media only screen and (max-width: 768px) {
      .email-container {padding: 16px;}
      .header-section, .content-section, .footer-section, .bottom-links {padding: 20px;}
    }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Inter; background-color: #f4f6f8;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr><td align="center" style="background-color: #f4f6f8; padding: 32px 16px;">
      <table width="640" cellpadding="0" cellspacing="0" border="0" style="max-width: 640px;">
        <tr><td>
          <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: white; border-radius: 20px; overflow: hidden;">
            <tr><td style="padding: 40px;">
              <table cellpadding="0" cellspacing="0" border="0"><tr>
                <img src="https://cdn.minicoursegenerator.com/assets/gateway/mcg-logo-wide.png" alt="MCG Logo" style="height: 32px" />
              </tr></table>
            </td></tr>
            <tr><td style="padding: 0 40px 0 40px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr><td style="color: #002e47; font-size: 18px; font-weight: 500; padding-bottom: 16px;">Hi,</td></tr>
                <tr><td style="color: #002e47; font-size: 18px; font-weight: 500; padding-bottom: 16px;">Here is your verification code to continue with {CollectionName}:</td></tr>
                <tr><td style="color: #015ffb; font-size: 24px; font-weight: 600; line-height: 36px; padding-bottom: 16px;">{EmailCode}</td></tr>
                <tr><td style="color: #002e47; font-size: 16px; font-weight: 400; line-height: 24px; padding-bottom: 16px;">Please do not share it with anyone.</td></tr>
                <tr><td style="color: #002e47; font-size: 14px; font-weight: 400; line-height: 21px; padding-bottom: 20px;">If you didn't request this code, you can safely ignore this email or <a href="#" style="color: #002e47; text-decoration: underline;">contact our support team.</a></td></tr>
                <tr><td style="height: 1px; background-color: #e5e7eb;"></td></tr>
              </table>
            </td></tr>
            <tr><td style="padding: 40px; background-color: white;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr><td style="color: #637381; font-size: 14px; font-weight: 400; line-height: 21px;">Mini Course Generator is the platform for creating and delivering educational content in the fastest way. 💙</td></tr>
              </table>
            </td></tr>
          </table>
        </td></tr>
        <tr><td style="padding: 20px 40px;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
            <tr><td align="center">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="padding-right: 20px;">
                    <a href="https://minicoursegenerator.com/privacy-policy" style="color: #838d98; font-size: 14px; font-family: Poppins, Arial, sans-serif; font-weight: 400; text-decoration: underline; line-height: 24px;">Privacy Policy</a>
                  </td>
                  <td style="width: 1px; height: 20px; background-color: #838d98;"></td>
                  <td style="padding-left: 20px;">
                    <a href="mailto:support@minicoursegenerator.com" style="color: #838d98; font-size: 14px; font-family: Poppins, Arial, sans-serif; font-weight: 400; text-decoration: underline; line-height: 24px;">Contact Support</a>
                  </td>
                </tr>
              </table>
            </td></tr>
            <tr><td align="center" style="padding-top: 16px;">
              <p style="color: #838d98; font-size: 14px; font-family: Poppins, Arial, sans-serif; font-weight: 400; line-height: 24px; margin: 0;">© 2025 Mini Course Generator</p>
            </td></tr>
          </table>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`,
    display: true,
  },
]
